export default __webpack_public_path__ + "244284a36543a8bb13870801a3f9b6ba.jpg";